module.exports = __webpack_public_path__ + "static/media/icon_arrow_circle_left.78c63923.svg";